import { useSelector } from 'react-redux';

const useTextCompanions = () => {
  const companions = [];
  const travelCart = useSelector((state) => state.search && state.search.travelCart);
  const data = travelCart.Passengers[0].Companions;
  data.forEach((companion) => {
    const obj = {
      label: companion.UserFullName,
      value: companion.UserKey,
    };
    companions.push(obj);
  });
  return [companions];
};

export default useTextCompanions;
